import React from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../../types/store.type';
import { Modal } from 'react-bootstrap';
import { ImageUnplugged } from '../../assets/images';
import './ErrorModal.scss';
import { TranslationUtils, ValidationUtils } from '../../utils';
import { flowId } from '../../logging/ddLogger';
import { ErrorsPrefix } from '../../types/errors.type';
import { MaintenanceConfig, Splits } from '../../types/split.type';
import { useFeatureConfig } from '../../services/optimizely/optimizelyHelper';

export const ErrorModal: React.FC = () => {
    const { error: tripError, unit } = useSelector((store: StoreState) => store.trip);
    const { isEnabled: isMaintenanceEnabled } = useFeatureConfig<MaintenanceConfig>(Splits.GUESTS_PORTAL_MAINTENANCE, true);
    let localPhoneNumber = ValidationUtils.validateAndGetEnvVar('REACT_APP_TOLL_FREE_PHONE_NUMBER');

    if (unit && unit.local_phone_number) {
        localPhoneNumber = unit.local_phone_number;
    }

    const handleClose = () => null;

    const shouldShowErrorModal = !!tripError && !isMaintenanceEnabled;

    const errorPrefix = tripError?.errorPrefix ? tripError?.errorPrefix : ErrorsPrefix.EXCEPTION;
    return (
        <Modal id={'error-modal'} backdropClassName={'custom-modal-backdrop'} show={shouldShowErrorModal} onHide={handleClose}>
            <Modal.Header />
            <Modal.Body className={'error-modal-body'}>
                <div>
                    <ImageUnplugged className="error-modal-image" />
                </div>
                <h4 className={'heading-med-light'}>{TranslationUtils.get('somethings_not_right')}</h4>
                <div className="error-modal-instructions">
                    <p className={'body-regular'}>{TranslationUtils.get('try_later_or_call')}</p>
                    <span className={'body-regular'}>
                        [ <a href={`tel:${localPhoneNumber}`}>{localPhoneNumber}</a> ]
                    </span>
                </div>
                <div className="error-flow-id">
                    <span className="body-regular text-muted">{`ref: ${errorPrefix}-${flowId}`}</span>
                </div>
            </Modal.Body>
        </Modal>
    );
};
